// extracted by mini-css-extract-plugin
export default {"button":"styles_button__o7q5I"};